import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($options.classes)
  }, [
    _createElementVNode("img", {
      src: $props.imageUrl,
      alt: $props.alt
    }, null, 8 /* PROPS */, _hoisted_1)
  ], 2 /* CLASS */))
}